<template>
  <v-card class="time-picker">
    <v-card-text class="pt-8 pb-0">
      <ul ref="outer" class="time-picker-times">
        <li
          v-for="item in times"
          :key="item.value"
          class="select-none cursor-pointer"
          :class="{'is-disabled': !item.enabled, 'is-selected': item.value === selected}"
          @click.prevent="onSelected(item)"
        >
          <span>{{ item.hour}}</span>
          <span>:</span>
          <span>{{ item.minute}}</span>
        </li>
      </ul>
    </v-card-text>
    <v-card-actions>
      <v-spacer/>
      <v-btn text color="primary" @click="onCancel">キャンセル</v-btn>
      <v-btn text color="primary" @click="onOK">OK</v-btn>
    </v-card-actions>
  </v-card>
</template>

<style lang="scss">
@import '@/libs/vuetify/styles/variables.scss';

.time-picker-times {
  $item-height: 48px;
  $lines: 7;
  $picker-height: $lines * $item-height;
  $margin-vert: ($picker-height - $item-height) / 2;

  height: $picker-height;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
  padding-left: 0 !important;

  > li {
    display: block;
    text-align: center;
    font-size: 16px;
    line-height: $item-height;
    letter-spacing: .1em;
    color: $title-black-text-color;

    &:first-child {
      margin-top: $margin-vert;
    }

    &:last-child {
      margin-bottom: $margin-vert;
    }

    &.is-disabled {
      color: $disabled-black-text-color;
    }

    &.is-selected {
      font-size: 34px;
      font-weight: bold;
      letter-spacing: .05em;
      color: $primary-color;
    }
  }
}
</style>

<script>
function timeValue (s) {
  const h = s.slice(0, 2) - 0
  const m = s.slice(3, 5) - 0
  return 0 | (h * 60 + m)
}

function timeHour (value) {
  const h = Math.floor(value / 60)
  return ('0' + h).slice(-2)
}

function timeMinute (value) {
  const m = value % 60
  return ('0' + m).slice(-2)
}

export default {
  name: 'TimePicker',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    range: {
      type: Object,
      required: true
    },
    enables: {
      type: Object,
      default: null
    },
    step: {
      type: Number,
      default: 30
    }
  },
  data () {
    return {
      selected: this.value,
      animID: 0
    }
  },
  computed: {
    times () {
      // range = [1030, 1800] ... times = [1030, 1100, 1130, ... 1800]
      const min = Math.ceil(timeValue(this.range.begin) / this.step) * this.step
      const max = Math.floor(timeValue(this.range.end) / this.step) * this.step
      const begin = !this.enables ? min : Math.ceil(timeValue(this.enables.begin) / this.step) * this.step
      const end = !this.enables ? max : Math.ceil(timeValue(this.enables.end) / this.step) * this.step

      const times = []
      for (var t = min; t <= max; t += this.step) {
        const hour = timeHour(t)
        const minute = timeMinute(t)

        times.push({
          value: hour + ':' + minute,
          hour,
          minute,
          enabled: (begin <= t) && (t <= end)
        })
      }
      return times
    }
  },
  mounted () {
    this.centering(false)
  },
  methods: {
    onSelected (item) {
      if (!item.enabled) {
        return
      }

      if (item.value === this.selected) {
        return
      }

      this.selected = item.value
      this.$nextTick(() => this.centering(true))
    },

    onCancel () {
      this.selected = this.value
      this.$emit('close')
    },

    onOK () {
      this.$emit('change', this.selected)
      this.$emit('close')
    },

    centering (animate) {
      const outer = this.$refs.outer
      const sel = outer.querySelector('.is-selected')
      if (!sel) {
        return
      }

      // アニメーションを停止する
      if (this.animID) {
        clearInterval(this.animID)
        this.animID = 0
      }

      // 移動量を算出する
      let from = outer.scrollTop
      const to = sel.offsetTop - outer.offsetTop - 148
      if (from === to) {
        return
      }
      if (!animate) {
        outer.scrollTop = to
        return
      }

      // 変化量を算出する
      let delta
      if (from < to) {
        delta = Math.ceil((to - from) / 6)
      } else {
        delta = 0 - Math.ceil((from - to) / 6)
      }

      // アニメーションを実行する
      this.animID = setInterval(() => {
        from += delta

        if ((delta >= 0) && (from >= to)) {
          // do clear
        } else if ((delta < 0) && (from <= to)) {
          // do clear
        } else {
          outer.scrollTop = from
          return
        }

        clearInterval(this.animID)
        this.animID = 0
        outer.scrollTop = to
      }, 16)
    }
  }
}
</script>
